import React, { useState } from 'react';
import {
  Box,
  Button,
  Input,
  Text,
  VStack,
  Field,
  InputGroup,
  Icon,
  Image,
  Link,
  Alert,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from "yup";
import BaseProgressCircle from '../../../../components/BaseProgressCircle';
import AuthCard from '../../components/AuthCard';
import { useLocation, useNavigate } from 'react-router';
import { LOGIN } from '../../../../constants/routes';
import PasswordInputField from "@/components/PasswordInputField";

const validationSchema = Yup.object().shape({
    newPassword1: Yup.string()
      .min(8, "New password must be at least 8 characters")
      .required("New password is required"),
  
    newPassword2: Yup.string()
      .oneOf([Yup.ref("newPassword1")], "Passwords not  match")
      .required("Confirm password is required"),
  });

export interface CreatePasswordData {
    email: string;
    newPassword1: string;
    newPassword2: string;
}

interface CreatePasswordFormProps {
  onCreatePasswordSubmit: (formData: CreatePasswordData, setError: (error: string) => void) => Promise<void>;
}

export default function CreatePasswordForm ({ onCreatePasswordSubmit }: CreatePasswordFormProps) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const [showPasswords, setShowPasswords] = useState({
    newPassword1: false,
    newPassword2: false,
  });

  const toggleVisibility = (field: keyof typeof showPasswords) => {
    setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const {
    handleSubmit,
    values,
    handleChange,
    errors,
    touched,
  } = useFormik<CreatePasswordData>({
    initialValues: {
      email: state?.email,
      newPassword1: '',
      newPassword2: '',
    },
    onSubmit: async (formData) => {
      console.log('formData', formData)
      setLoading(true);
      await onCreatePasswordSubmit(formData, setError);
      setLoading(false);
    },
    validationSchema
  });


  return (
    <AuthCard title="Change Password" onClose={() => navigate(LOGIN)}>
      <form onSubmit={handleSubmit}>
        <VStack align="stretch" gap={4}>
          <VStack gap={4}>
            <Field.Root invalid={touched.newPassword1 && Boolean(errors.newPassword1)}>
            <PasswordInputField
                label="New password"
                name="newPassword1"
                value={values.newPassword1}
                error={errors.newPassword1}
                touched={touched.newPassword1}
                show={showPasswords.newPassword1}
                onToggle={() => toggleVisibility("newPassword1")}
                onChange={handleChange}
            />
            </Field.Root>

            <Field.Root invalid={touched.newPassword2 && Boolean(errors.newPassword2)}>
            <PasswordInputField
                label="Confirm password"
                name="newPassword2"
                value={values.newPassword2}
                error={errors.newPassword2}
                touched={touched.newPassword2}
                show={showPasswords.newPassword2}
                onToggle={() => toggleVisibility("newPassword2")}
                onChange={handleChange}
            />

            </Field.Root>
          </VStack>

          <Button 
            colorPalette="brand" 
            type="submit" 
            size='lg' 
            w='260px' 
            borderRadius={15} 
            alignSelf='center'
            mt={8}
            disabled={loading}
          >
            {loading ? <BaseProgressCircle /> : "SIGN IN"}
          </Button>

          {error && (
            <Alert.Root status="error">
              <Alert.Indicator />
              <Alert.Title>{error}</Alert.Title>
            </Alert.Root>
          )}
        </VStack>
      </form>
    </AuthCard>
  );
};
